import {OUTLETS} from '../content/parties';
import {DM,on} from '../content/settings';
import {blocker,debtLimit} from './budget';
import {approval,startGovern,toast} from './govern';
import {press} from './media';
import {choice,rnd} from './rng';
import {satWith} from './rules';
import {S,log} from './state';
import {clamp} from './util';

export const wingAvg:any=()=>(S.wing.soz+S.wing.wirt)/2;
export function wingReact(fx?:any,mult=1){
  if(!on('wings')||!fx)return;const p=fx.pos||{};
  S.wing.soz=clamp(S.wing.soz+clamp(((p.sozial||0)*3+(p.steuern||0)*1.5+(p.wohnen||0)+(p.klima||0)*.5)*mult,-10,10),0,100);
  S.wing.wirt=clamp(S.wing.wirt+clamp((-(p.sozial||0)*1.5+(p.buero||0)*2.5-(p.steuern||0)*2-Math.max(0,p.haushalt||0))*mult,-10,10),0,100);
}
export function wingTick(){
  if(!on('wings'))return false;let att=false;
  S.wing.soz+=(55-S.wing.soz)*.01;S.wing.wirt+=(55-S.wing.wirt)*.01;
  if(S.saldo<debtLimit())S.wing.wirt=clamp(S.wing.wirt-.3*DM(),0,100);
  S.basis+=(wingAvg()-55)*.0015;S.basis*=.996;
  for(const k of ['soz','wirt'])if(S.wing[k]<15&&rnd()<.04*DM()){S.basis-=1.5;S.wing[k]+=10;
    log(`Prominente Mitglieder des ${k==='soz'?'sozialen':'wirtschaftsliberalen'} Flügels treten aus der Partei aus.`,'bad');press(OUTLETS[0].n,`Parteiaustritte: ${S.name} verliert prominente Köpfe`,-1.2);att=true}
  const rel=S.m-S.m0;
  if(!S.ptag&&S.ptagLeg!==S.leg&&rel>=20&&!blocker()){S.ptagLeg=S.leg;
    const weak=S.wing.soz<=S.wing.wirt?'soz':'wirt';
    const mot=weak==='soz'?choice([{t:'Vermögensteuer ins Parteiprogramm',ax:'steuern',dir:1},{t:'Mietendeckel als Parteiziel',ax:'wohnen',dir:1},{t:'Mehr Sozialstaat, auch mit höheren Abgaben',ax:'sozial',dir:1}])
      :choice([{t:'Strikte Einhaltung der Schuldenbremse',ax:'haushalt',dir:-1},{t:'Radikaler Bürokratieabbau',ax:'buero',dir:1},{t:'Keine neuen Steuern',ax:'steuern',dir:-1}]);
    S.ptag={weak,mot};log(`Bundesparteitag von ${S.name}: Der ${weak==='soz'?'soziale':'wirtschaftsliberale'} Flügel stellt einen Antrag.`);toast('Bundesparteitag','');att=true}
  return att;
}
export function decidePtag(acc?:any){
  const P=S.ptag,w=P.weak,o=w==='soz'?'wirt':'soz',a=P.mot.ax;S.ptag=null;
  if(acc){S.wing[w]=clamp(S.wing[w]+20,0,100);S.wing[o]=clamp(S.wing[o]-10,0,100);S.you[a]=clamp(S.you[a]+P.mot.dir,-2,2);
    log(`Der Parteitag beschließt: ${P.mot.t}. Euer Programm verschiebt sich.`)}
  else{S.wing[w]=clamp(S.wing[w]-12,0,100);S.basis-=.5;log(`Die Parteiführung lässt den Antrag „${P.mot.t}“ scheitern.`,'bad')}
  const v=Math.round(clamp(40+wingAvg()*.5+(approval()-45)*.5+(rnd()*6-3),30,98));
  if(v<60){S.basis-=1;press(OUTLETS[0].n,`Denkzettel: Parteichefin nur mit ${v} Prozent wiedergewählt`,-1.5)}
  else if(v>85){S.basis+=.5;press(OUTLETS[0].n,`Rückenwind: Wiederwahl mit ${v} Prozent`,1)}
  else press(OUTLETS[0].n,`Parteitag bestätigt Führung mit ${v} Prozent`,.2);
  log(`Wiederwahl als Parteivorsitz mit ${v} Prozent.`,v>=60?'good':'bad');
}
export function memberVote(ys?:any,rand=true){return clamp(50+(ys-.72)*160+(wingAvg()-55)*.4+(rand?rnd()*8-4:0),10,95)}
export function trySign(){
  if(on('wings')&&S.partners.length){const v=memberVote(satWith('YOU',S.agree));
    if(v<50){S.memberFail=Math.round(v);log(`Mitgliederentscheid: Nur ${Math.round(v)} Prozent stimmen dem Koalitionsvertrag zu. Ihr müsst nachverhandeln.`,'bad');S.wing.soz-=5;S.wing.wirt-=5;return}
    log(`Mitgliederentscheid: ${Math.round(v)} Prozent stimmen dem Koalitionsvertrag zu.`,'good')}
  S.memberFail=null;startGovern();
}

